// extracted by mini-css-extract-plugin
module.exports = {"root":"html-editor_root__u9Lfr"};